//@ts-check
import { forwardRef } from 'react';

import { useActionStep } from '../hooks/useActionStep';

const OpenSearchStep = forwardRef(
  /**
   * @param {{
   *  onSuccess?: () => void,
   *  onFail?: () => void,
   * }} props
   * @param {React.Ref<any>} ref
   */
  ({ onSuccess, onFail }, ref) => {
    return useActionStep(ref, {
      onSuccess,
      onFail,
      name: 'OpenSearch check',
      action: 'check-opensearch',
      data: {},
      onResponse: (data, log) => {
        if (data.documents.length === 0) {
          log.fatal(`No data found in OpenSearch in the past 15min`);
          return false;
        }

        log.info(`Found ${data.documents.length} documents in OpenSearch in the past 15min`);

        for (let index = 0; index < data.documents.length; index++) {
          const document = data.documents[index];

          log.info(`${document._index} = ${JSON.stringify(document._source)}`);

          /*
          for (const key of Object.keys(document)) {
            log.info(`${key} = ${JSON.stringify(document[key])}`);
          }
          */
        }
      },
    });
  }
);

export default OpenSearchStep;
